$(document).ready(function() {

    $('.js-ajax-submit').on('submit', function(e) {

        e.preventDefault();
        $.ajax({

            url: this.action,
            type: this.method,
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            data: $(this).serialize(),

            beforeSend: function() {
                $('.form-control').removeClass('is-invalid').next('.invalid-feedback').text('');
            },

            error: function(data) {
                let errors = data.responseJSON.errors;
                Object.keys(errors).forEach(fieldName => {
                    let errorMessage = errors[fieldName][0];
                    let field = $('[name="'+ fieldName +'"]');
                    field.addClass('is-invalid')
                        .next('.invalid-feedback')
                        .text(errorMessage);
                });
            },

            success: function(response) {
                $('.form-control').val('');

                if (response.redirect) {
                    window.location = response.redirect;
                }

                if (response.message) {
                    $.notify({message: response.message}, {
                        offset: 50,
                        type: (response.type === 'danger') ? 'danger' : 'success',
                    });
                }

            },

        });

    });

});
